import { jsx as a } from "react/jsx-runtime";
import { CardSlotClass as C } from "../Card.types.js";
import { propagateTestid as S } from "../../../helpers/utility/propagateTestid.js";
function x({
  children: s,
  "data-testid": d,
  footer: i,
  heading: e,
  media: n,
  prepend: p,
  topRight: l
} = {}, m = {}) {
  const c = typeof e == "string" ? /* @__PURE__ */ a("h2", { children: e }) : e, f = { ...C, ...m }, r = [
    [p, "prepend", "Prepend"],
    [l, "topRight", "TopRight"],
    [n, "media", "Media"],
    [c, "heading", "Heading"],
    [s, "body", "Children"],
    [i, "footer", "Footer"]
  ];
  return r.some(([t, o]) => o !== "body" && t) ? r.filter(([t]) => !!t).map(([t, o, h]) => /* @__PURE__ */ a(
    "div",
    {
      className: f[h],
      "data-testid": S(d, o),
      children: t
    },
    o
  )) : s;
}
export {
  x as composeIDSCardSlots
};
